var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.731%",
    y1: "7.282%",
    x2: "77.407%",
    y2: "86.444%",
    id: "NoContent_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BCCE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2F5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "38.667%",
    x2: "55.502%",
    y2: "47.893%",
    id: "NoContent_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BECF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.757%",
    y1: "32.439%",
    x2: "59.598%",
    y2: "41.51%",
    id: "NoContent_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB7C9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA4BD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "38.667%",
    x2: "55.502%",
    y2: "47.893%",
    id: "NoContent_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BECF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.757%",
    y1: "33.117%",
    x2: "59.598%",
    y2: "41.837%",
    id: "NoContent_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB7C9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA4BD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "28.737%",
    x2: "55.502%",
    y2: "46.048%",
    id: "NoContent_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BECF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.021%",
    y1: "10.274%",
    x2: "44.021%",
    y2: "38.555%",
    id: "NoContent_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFD0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A84A4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.341%",
    y1: "30.836%",
    x2: "97.362%",
    y2: "44.076%",
    id: "NoContent_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE0E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CDDB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.515%",
    y1: "18.576%",
    x2: "35.228%",
    y2: "50%",
    id: "NoContent_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABB1C6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.758%",
    y1: "61.136%",
    x2: "50%",
    y2: "35.622%",
    id: "NoContent_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A83A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7C9E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.3%",
    y1: "38.667%",
    x2: "17.173%",
    y2: "54.874%",
    id: "NoContent_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EAF2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDFE8",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.64%",
    y1: "35.999%",
    x2: "48.087%",
    y2: "44.374%",
    id: "NoContent_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D4E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABB1C6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.109%",
    y1: "52.806%",
    x2: "63.962%",
    y2: "46.133%",
    id: "NoContent_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A92AF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7C9E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.286C8.735 9.076 18.186 4.387 28.351.22c3.986-1.252 15.08 5.985 15.494 6.156.275.114-4.584 4.702-14.577 13.765l-15.748.812L0 14.286z",
    id: "NoContent_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.286C8.735 9.076 18.186 4.387 28.351.22c3.986-1.252 15.08 5.985 15.494 6.156.275.114-4.584 4.702-14.577 13.765l-15.748.812L0 14.286z",
    id: "NoContent_svg__i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.571C5.241 5.446 10.911 2.632 17.01.131c2.392-.75 9.05 3.592 9.297 3.694.165.069-2.75 2.822-8.746 8.26l-9.449.487-8.112-4z",
    id: "NoContent_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.302C11.888 2.825 19.086.086 21.595.086c2.508 0 12.07 4.562 28.686 13.685L25.983 32.876 7.038 18.823 0 8.303z",
    id: "NoContent_svg__o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.07 9.395C12.58 3.247 21.345.173 26.36.173c5.017 0 24.142 9.123 57.373 27.368l-48.596 38.21L4.82 32.963.071 9.395z",
    id: "NoContent_svg__s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 46.428C28.39 29.496 59.103 14.258 92.141.715c12.953-4.07 49.012 19.45 50.355 20.006.894.37-14.897 15.283-47.375 44.737l-51.18 2.64L0 46.428z",
    id: "NoContent_svg__x"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "35.281%",
    cy: "38.699%",
    fx: "35.281%",
    fy: "38.699%",
    r: "65.428%",
    id: "NoContent_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA7C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C94B0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "NoContent_svg__a",
    cx: 65.808,
    cy: 65.737,
    r: 65.737
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__b)",
    xlinkHref: "#NoContent_svg__a"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.6,
    mask: "url(#NoContent_svg__c)",
    cx: 101.761,
    cy: 39.705,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.6,
    mask: "url(#NoContent_svg__c)",
    cx: 114.645,
    cy: 41.02,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    mask: "url(#NoContent_svg__c)",
    cx: 10.518,
    cy: 46.805,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.3,
    mask: "url(#NoContent_svg__c)",
    cx: 61.004,
    cy: 26.821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.9,
    mask: "url(#NoContent_svg__c)",
    cx: 79.147,
    cy: 18.669,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.7,
    mask: "url(#NoContent_svg__c)",
    cx: 52.327,
    cy: 18.669,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    mask: "url(#NoContent_svg__c)",
    cx: 89.665,
    cy: 26.558,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.7,
    mask: "url(#NoContent_svg__c)",
    cx: 67.052,
    cy: 17.092,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.8,
    mask: "url(#NoContent_svg__c)",
    cx: 16.566,
    cy: 34.972,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.7,
    mask: "url(#NoContent_svg__c)",
    cx: 15.777,
    cy: 52.064,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.9,
    mask: "url(#NoContent_svg__c)",
    cx: 77.57,
    cy: 27.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#NoContent_svg__d)",
    mask: "url(#NoContent_svg__c)",
    cx: 36.287,
    cy: 36.813,
    r: 6.837
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoContent_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 114.12 67.315)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__f)",
    xlinkHref: "#NoContent_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.074-.218c3.218.041 4.19.462 2.916 1.263-1.912 1.2-4.818 3.067-4.818 5.519s6.068 3.18 4.442 5.65c-1.105 1.854-7.85 4.892-20.233 9.114l21.515 1.043 7.272-2.597 8.326-16.087-2.79-2.642L29.284-.81l-3.21.59z",
    fill: "url(#NoContent_svg__g)",
    mask: "url(#NoContent_svg__h)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoContent_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 68.892 65.211)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__f)",
    xlinkHref: "#NoContent_svg__i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.074-.218c3.155-.232 4.225.272 3.21 1.513-1.524 1.86-2.02 2.786-2.02 5.238 0 2.452 2.976 3.211 1.35 5.681-1.105 1.854-7.85 4.892-20.233 9.114l21.515 1.043 7.272-2.597 8.326-16.087-2.79-2.642L29.284-.81l-3.21.59z",
    fill: "url(#NoContent_svg__g)",
    mask: "url(#NoContent_svg__j)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoContent_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 73.625 64.685)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__l)",
    xlinkHref: "#NoContent_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 2.873c0 1.861-.603 3.289-1.579 4.77-.663 1.113-4.835 2.83-12.517 5.154l12.909.625 4.363-1.558 4.995-9.652L25.622.627c-3.907-.844-6.54-1.053-7.9-.627-1.05.526 1.403 1.013 1.403 2.873z",
    fill: "url(#NoContent_svg__m)",
    mask: "url(#NoContent_svg__n)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoContent_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.701 65.737)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__o"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__p)",
    xlinkHref: "#NoContent_svg__o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.264-.789c-1.794.518-2.35 1.132-1.67 1.843 1.023 1.067 3.82 4.24 2.084 7.103-1.737 2.864-7.67 1.352-8.434 3.947-.764 2.594.903 10.022 14.206 15.426 8.87 3.603 7.199 6.239-5.012 7.906L5.711 14.698l-7.333-8.032L9.172-.327l14.092-.462z",
    fill: "url(#NoContent_svg__q)",
    mask: "url(#NoContent_svg__r)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoContent_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.992 60.305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__s"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__t)",
    xlinkHref: "#NoContent_svg__s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7-1.578C25.61-.447 24.247.83 25.61 2.252c2.045 2.133 15.236 8.337 11.764 14.063C33.9 22.04 26.177 22.18 26.985 27.06c.808 4.88 15.511 12.165 42.119 22.974C86.842 57.24 74.49 64.187 32.048 70.87L-5.406 29.396-7.363 5.432 1.515-.654 29.7-1.578z",
    fill: "url(#NoContent_svg__u)",
    mask: "url(#NoContent_svg__v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.866 26.403c.687 5.526 15.63 12.823 42.238 23.632C86.842 57.24 74.49 64.187 32.048 70.87l-19.752-23.78c9.72-13.642 14.577-20.538 14.57-20.688z",
    fill: "url(#NoContent_svg__w)",
    mask: "url(#NoContent_svg__v)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#NoContent_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.304 68.367)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "NoContent_svg__A",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NoContent_svg__x"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#NoContent_svg__y)",
    xlinkHref: "#NoContent_svg__x"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.74-.71C95.2-.573 98.36.795 94.217 3.396c-6.213 3.9-15.657 9.969-15.657 17.937 0 7.97 19.721 10.337 14.435 18.365-3.592 6.024-25.51 15.897-65.756 29.62l69.924 3.387 23.632-8.44 27.06-52.281-9.068-8.588L95.172-2.63 84.74-.71z",
    fill: "url(#NoContent_svg__z)",
    mask: "url(#NoContent_svg__A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.363 35.16c.749 1.322.778 2.797-.368 4.537-3.592 6.024-25.51 15.897-65.756 29.62l69.924 3.387 16.512-7.92C100.208 45.032 93.437 35.156 93.363 35.16z",
    fill: "url(#NoContent_svg__B)",
    mask: "url(#NoContent_svg__A)"
  }))))));
}
export default SvgNoContent;